import styled from 'styled-components';
import IconButton from 'components/IconButton';
import { getThemeColor } from 'utils/styled';
import { AvatarStyleProps } from './types';

export const Root = styled.div<AvatarStyleProps>`
  align-items: center;
  background-color: ${getThemeColor('actionSecondary')};
  border-radius: 50%;
  color: ${getThemeColor('white')};
  cursor: default;
  display: flex;
  font-family: ${({ theme }) => theme.typography.fontFamily.secondary};
  font-size: ${(props) => props.$size / 2}px;
  font-weight: 800;
  height: ${(props) => props.$size}px;
  justify-content: center;
  user-select: none;
  width: ${(props) => props.$size}px;
`;

export const Button = styled(IconButton).attrs({
  variant: 'solid',
  color: 'secondary',
})`
  height: auto;
  width: auto;

  ${Root} {
    background-color: transparent;
  }
`;
